import {
  BookingStatus,
  LoadStatus,
  SalesOrderStatus,
} from '@rematter/frontend-lib-api-client';
import {
  ConversationSnapshot,
  ParticipantSnapshot,
  UserSnapshot,
} from 'talkjs/all';

export type ParticipantCandidate = {
  id: string;
  type: 'internal' | 'external';
  name: string;
  email?: string;
  phoneNumber?: string;
  organizationName?: string;
  userId?: string;
};

export type IContact = Omit<ParticipantSnapshot, 'user'> & {
  user: Omit<UserSnapshot, 'custom'> & {
    custom: {
      contactType: 'internal' | 'external';
      organizationName: string;
      email: string;
      phone: string;
      isOnline: boolean;
      applicationUserId: string;
    };
  };
};

export type IConversation = Omit<ConversationSnapshot, 'custom'> & {
  participants?: IContact[];
  custom: {
    conversationType: 'internal' | 'external';
    objectsData: ObjectListEntry[];
    isDeleted?: 'true' | 'false';
  };
};

export type ConversationObject = {
  ObjectId: string;
  ObjectDescription: string;
  ObjectType: string;
};

export const presetFilters = ['all', 'unread', 'internal', 'external'] as const;

export type ObjectListEntry = {
  id: string;
  type: 'load' | 'salesorder' | 'booking';
  title: string;
  status: LoadStatus | SalesOrderStatus | BookingStatus;
  subtitle: string;
};
